export const MOCK_SIGNIT_PATH = "/mock/signit";
export const SIGNIT_RETURN_URL_PARAM = "returnUrl";
export const DIGITAL_SIGNATURE_RETURN_TOKEN_PARAM = "signingReturnToken";
export const MOCK_SIGNIT_FIELDS_PARAM = "fields";

export const buildMockSignItUrl = ({
  port,
  returnUrl,
  fieldLabels,
}: {
  port: number;
  returnUrl?: string;
  fieldLabels: string[];
}): string => {
  const params = new URLSearchParams();
  if (returnUrl) params.set(SIGNIT_RETURN_URL_PARAM, returnUrl);
  fieldLabels.forEach((label) =>
    params.append(MOCK_SIGNIT_FIELDS_PARAM, label),
  );

  return `http://localhost:${port}${MOCK_SIGNIT_PATH}?${params.toString()}`;
};
